<template>
  <div class="wrapper">
    <div class="row">
      <div class="col-lg-12 border-black">
        <div id="filters">
          <div class="search">
            <div class="row">
              <div class="col-lg-3 col-md-3 m-t-sm">
                <input placeholder="Domain" type="text" v-model="filters['domain']" class="form-control" id="id-domain" @keypress.enter="loadTags">
              </div>
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                    placeholder="Clients"
                    :options="[{name: 'No Client', id: ''}].concat(f.clients)"
                    label="name"
                    index="id"
                    multiple
                    v-model="filters['clients']"
                    @input="loadTags"
                ></v-select>
              </div>
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                    placeholder="Tags"
                    v-model="filters['tags']"
                    multiple
                    :options="defaultTags"
                    @input="loadTags"
                ></v-select>
              </div>
              <div class="col-lg-3 col-md-3 m-t-sm">
                <div class="input-group">
                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Domains</div>
                  <input type="number" v-model="filters['linksFrom']" min="0" name="" placeholder="from" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="loadTags">
                  <input type="number" v-model="filters['linksTo']" min="0" name="" placeholder="to" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="loadTags">
                </div>
              </div>
            </div>
          </div>
          <div class="m-t-sm">
            <button class="btn btn-xs btn-primary" @click="loadTags">Search</button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 m-t-sm" v-if="tags.length">
        <h4>Showing {{ tagsMeta.count }} results</h4>
      </div>
      <div class="col-lg-12 col-md-12 m-t-sm">
        <aDataTable :data="tags">
          <template #columns>
            <tr>
              <th>Domain</th>
              <th>Client</th>
              <th>Tags</th>
              <th>Domains</th>
            </tr>
          </template>
          <template #rows>
            <tr v-for="tag in tags" :key="tag.id">
              <td class="col-lg-2">
                <router-link :to="'/pbn/link-tags/' + tag.domain">{{ tag.decodedDomain }}</router-link>
                <a :href="'https://' + tag.domain" target="_blank"><i class="fa fa-external-link"></i></a></td>
              <td class="col-lg-2">
                <e-txt
                  type="select"
                  :value="tag.client ? tag.client.name : '/'"
                  :selected-value="tag.client ? tag.client.id : ''"
                  :options="f.clients"
                  select-value="id"
                  select-label="name"
                  :text="tag.client ? tag.client.name : '/'"
                  @input="updateTag($event, 'client', tag.domain)"
                  close-on-save="true"
                ></e-txt>
              </td>
              <td class="col-lg-6">
                <v-select
                  multiple
                  :value="tag.tags"
                  :options="defaultTags"
                  @input="updateTag($event.join(','), 'tags', tag.domain)"
                ></v-select>
              </td>
              <td>
                {{ tag.siteCount }}
              </td>
            </tr>
          </template>
        </aDataTable>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Query } from '../../../../../mixins/helperMixin'
import EditText from '../../../../Helpers/Form/EditText'

export default {
  data () {
    return {
      filters: {},
      tags: [],
      defaultTags: ['money', 'pbn', 'authority', 'dev', 'unknown'],
      tagsMeta: {}
    }
  },
  components: {
    eTxt: EditText
  },
  mixins: [Query],
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  methods: {
    loadTags () {
      this.filters.limit = 200
      axios.get('/pbn/links/tags?' + this.buildQuery(this.filters))
        .then(r => {
          this.tags = r.data.data
          this.tagsMeta = r.data.meta
        })
        .catch()
    },
    updateTag (val, prop, domain) {
      let data = {}
      data[prop] = val
      axios.patch('/pbn/links/tag/' + domain, data)
        .then(r => {
          console.log('yo')
        })
        .catch(e => {
          this.$toastr.eraser(e.response.data.msg, 'Load failed')
        })
    }
  }
}
</script>
<style>
#id-domain {
  border-radius: 4px;
  height: 31px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Tags/Tags.vue